var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fallback"},[_c('router-link',{staticClass:"back-button",attrs:{"to":("/location/detail/" + (_vm.currentLocation.slug))}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_c('div',{attrs:{"id":"ARFallbackCanvas"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }